import CardWrapper from '../card-wrapper';
import Step03Image from '../../../../../assets/images/memory/onboarding/step-03-02.svg';
import { Typography } from '../../../../../core/components/molecules/Typography';
import StepButton from '../step-button';
import { Icon } from '../../../../../core/components/atoms/Icon';

const Step03C = ({
  onNextStep,
  onPreviousStep,
}: {
  onNextStep: () => void;
  onPreviousStep: () => void;
}) => {
  return (
    <CardWrapper.Root side='left'>
      <CardWrapper.Primary className='flex flex-col items-center justify-center gap-4 px-5'>
        <div className='flex w-full flex-col items-start justify-center gap-4'>
          <Typography
            title='h1'
            className='!text-h1 font-bold text-mono-color-darker'
          >
            <i>Flashcards</i>
          </Typography>
          <Typography
            title='h3'
            className='!text-h3 font-bold text-mono-color-darker'
          >
            Editando um <i>flashcard</i>
          </Typography>
          <Typography className='!text-md !font-normal text-mono-color-darker'>
            Para editar um <i>Flashcard</i>, basta clicar no <i>Flashcard</i> e
            em seguida, Editar.
          </Typography>
        </div>
        <div className='flex w-full justify-end'>
          <StepButton label='Voltar' onClick={onPreviousStep} type='text' />
          <StepButton
            label='Continuar'
            onClick={onNextStep}
            icon={<Icon Icon={'keyboard_arrow_right'} type='material' />}
          />
        </div>
      </CardWrapper.Primary>

      <CardWrapper.Secondary className='h-[679px] w-[476px] rounded-lg '>
        <img
          src={Step03Image}
          alt='Step 03-C'
          className='h-full w-full rounded-lg md:object-none'
        />
      </CardWrapper.Secondary>
    </CardWrapper.Root>
  );
};

export default Step03C;
